/** @jsx jsx **/
import { Flex, jsx } from 'theme-ui'
import { FC } from 'react'
import FilterBadge from '~/components/filter/filter-badge'
import { space } from '~/gatsby-plugin-theme-ui'

type Props = {
  selectedFilters: readonly string[]
  handleChange: (value: string) => void
}

const FilterSelectedItems: FC<Props> = ({ selectedFilters, handleChange }) => {
  return (
    <Flex
      sx={{
        flexWrap: 'wrap',
        mb: [0, null, space.md3],
        mt: [space.md2],
      }}
    >
      {selectedFilters.map((selectedFilter, index) => (
        <FilterBadge
          key={`chip-${index}-${selectedFilter}`}
          onClick={handleChange}
          value={selectedFilter}
        />
      ))}
    </Flex>
  )
}

export default FilterSelectedItems
